import React from 'react';
import { useActualites } from '../../../contexts/actualiteContext';
import { useLotsCommerciaux } from '../../../contexts/lotCommercialContext';
import Page from '../../Page';
import Actualite from './Actualite';

const Actualites = () => {

    // CONTEXTS
    const { actualites } = useActualites();
    const { lotCommercialActif } = useLotsCommerciaux();

    // RENDER
    return <Page title="Actualités">
        {actualites.map((actualite, index) => {
            const { datePublication, description, images, nationale, nomCommercial, titre } = actualite;
            const { perspective } = lotCommercialActif;

            let vignetteSrc = undefined;
            if (!nationale && !!perspective)
                vignetteSrc = `data:image/png;base64,${perspective}`;

            return <Actualite
                datePublication={datePublication}
                description={description}
                images={images}
                key={index}
                nomCommercial={nomCommercial}
                titre={titre}
                vignetteSrc={vignetteSrc}
            />;
        })}
    </Page>;

};

export default Actualites;